import React, { useState } from "react";
import NavMobile from "../Nav/NavMobile";
import NavWeb from "../Nav/NavWeb";
import Loader from "../../Loader/Loader";
import ScrollListCompanies from "../Grupos/ScrollListCompanies.jsx";
import ScrollListStudents from "./ScrollListStudents";
import { generateCompaniesReports } from "../../../provider/adm/MasiveReports/generateCompaniesReports";
import { generateStudentsReports } from "../../../provider/adm/MasiveReports/generateStudentsReports";
import { Download, Building2, Users, Mail, Calendar, FileText } from "lucide-react";
import { toast, Toaster } from 'sonner';

const FormReportesMasivos = () => {
  const [companySelectedToFilter, setCompanySelectedToFilter] = useState([]);
  const [studentSelectedToFilter, setStudentSelectedToFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [companyID, setCompanyID] = useState(null);
  const [studentID, setStudentID] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [isAllCompanies, setIsAllCompanies] = useState(false);
  const [isAllStudents, setIsAllStudents] = useState(false);
  const [downloadAsPdf, setDownloadAsPdf] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const handleGenerateCompaniesReport = async () => {
    if (!email) {
      toast.error("Por favor ingresa un email");
      return;
    }

    try {
      setLoading(true);
      // Si isAllCompanies es true, enviar array vacío
      // Si es false, construir la lista con los datos completos de las compañías
      const companies = isAllCompanies ? [] : companySelectedToFilter.map(selectedName => {
        // Buscar la compañía completa en la lista usando el nombre seleccionado
        const foundCompany = companyList.find(company =>
          company.name.trim().toLowerCase() === selectedName.trim().toLowerCase()
        );

        return foundCompany ? {
          id: foundCompany.id,
          name: foundCompany.name,
          nit: foundCompany.nit
        } : null;
      }).filter(Boolean); // Filtrar elementos null

      await generateCompaniesReports({
        companies: companies,
        isAll: isAllCompanies,
        emailToSend: email,
        downloadAsPdf: downloadAsPdf,
        year,
        month
      });

      toast.success("Reporte de compañías guardado exitosamente, por favor revisa tu correo electrónico");
    } catch (error) {
      toast.error("Error al generar reporte de compañías");
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateStudentsReport = async () => {
    if (!email) {
      toast.error("Por favor ingresa un email");
      return;
    }

    try {
      setLoading(true);
      // Si isAllStudents es true, enviar array vacío
      // Si es false, construir la lista con los datos completos de los estudiantes
      const students = isAllStudents ? [] : studentSelectedToFilter.map(selectedName => {
        // Buscar el estudiante completo en la lista usando el nombre seleccionado
        const foundStudent = studentList.find(student =>
          student.fullName.trim().toLowerCase() === selectedName.trim().toLowerCase()
        );

        return foundStudent ? {
          id: foundStudent.ID,
          fullName: foundStudent.fullName,
        } : null;
      }).filter(Boolean); // Filtrar elementos null

      await generateStudentsReports({
        students,
        isAll: isAllStudents,
        emailToSend: email,
        downloadAsPdf: downloadAsPdf,
        year,
        month
      });

      toast.success("Reporte de estudiantes guardado exitosamente, por favor revisa tu correo electrónico");
    } catch (error) {
      toast.error("Error al generar reporte de estudiantes");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {loading && <Loader />}
      <NavMobile />
      <NavWeb />

      <div className="flex-1 p-6 bg-gradient-to-br from-blue-50 to-indigo-100 overflow-y-auto" style={{ height: "100vh" }}>
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
            <div className="flex items-center gap-3 mb-2">
              <Download className="h-8 w-8 text-blue-600" />
              <h1 className="text-3xl font-bold text-gray-800">Reportes Masivos</h1>
            </div>
            <p className="text-gray-600">Genera y descarga reportes personalizados de compañías y estudiantes</p>
          </div>

          {/* Configuration Panel */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
            <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <Calendar className="h-5 w-5 text-blue-600" />
              Configuración del Reporte
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Año</label>
                <select
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {[2023, 2024, 2025, 2026].map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Mes</label>
                <select
                  value={month}
                  onChange={(e) => setMonth(parseInt(e.target.value))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(2024, i).toLocaleString('es', { month: 'long' })}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Mail className="h-4 w-4 inline mr-1" />
                  Email de Envío
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="correo@ejemplo.com"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            {/* PDF Download Toggle */}
            <div className="flex items-center justify-center gap-3 p-4 bg-gray-50 rounded-lg">
              <FileText className="h-5 w-5 text-red-600" />
              <span className="text-sm font-medium text-gray-700">Descargar como PDF</span>
              <label className="flex items-center gap-2 cursor-pointer">
                <div className={`relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full ${downloadAsPdf ? 'bg-red-600' : 'bg-gray-300'}`}>
                  <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition transform ${downloadAsPdf ? 'translate-x-6' : 'translate-x-0'}`}></div>
                </div>
                <input
                  type="checkbox"
                  checked={downloadAsPdf}
                  onChange={(e) => setDownloadAsPdf(e.target.checked)}
                  className="sr-only"
                />
              </label>
              <span className="text-xs text-gray-500">
                {downloadAsPdf ? 'PDF' : 'Excel'}
              </span>
            </div>
          </div>

          {/* Reports Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Companies Report */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold flex items-center gap-2">
                  <Building2 className="h-5 w-5 text-green-600" />
                  Reporte de Compañías
                </h3>

                <label className="flex items-center gap-2 cursor-pointer">
                  <span className="text-sm text-gray-600">Todas</span>
                  <div className={`relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full ${isAllCompanies ? 'bg-blue-600' : 'bg-gray-300'}`}>
                    <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition transform ${isAllCompanies ? 'translate-x-6' : 'translate-x-0'}`}></div>
                  </div>
                  <input
                    type="checkbox"
                    checked={isAllCompanies}
                    onChange={(e) => setIsAllCompanies(e.target.checked)}
                    className="sr-only"
                  />
                </label>
              </div>

              <div className="mb-4">
                <ScrollListCompanies
                  companySelectedToFilter={companySelectedToFilter}
                  setCompanySelectedToFilter={setCompanySelectedToFilter}
                  setLoading={setLoading}
                  setCompanyID={setCompanyID}
                  multiSelect={true}
                  disabled={isAllCompanies}
                  onCompanyListChange={setCompanyList} // Nueva prop para recibir la lista completa
                />
              </div>

              <button
                onClick={handleGenerateCompaniesReport}
                disabled={!email || loading}
                className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-medium py-3 px-4 rounded-lg transition duration-200 flex items-center justify-center gap-2"
              >
                <Download className="h-4 w-4" />
                Generar Reporte de Compañías
              </button>
            </div>

            {/* Students Report */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold flex items-center gap-2">
                  <Users className="h-5 w-5 text-purple-600" />
                  Reporte de Estudiantes
                </h3>

                <label className="flex items-center gap-2 cursor-pointer">
                  <span className="text-sm text-gray-600">Todos</span>
                  <div className={`relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full ${isAllStudents ? 'bg-blue-600' : 'bg-gray-300'}`}>
                    <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition transform ${isAllStudents ? 'translate-x-6' : 'translate-x-0'}`}></div>
                  </div>
                  <input
                    type="checkbox"
                    checked={isAllStudents}
                    onChange={(e) => setIsAllStudents(e.target.checked)}
                    className="sr-only"
                  />
                </label>
              </div>

              <div className="mb-4">
                <ScrollListStudents
                  studentSelectedToFilter={studentSelectedToFilter}
                  setStudentSelectedToFilter={setStudentSelectedToFilter}
                  setLoading={setLoading}
                  setStudentID={setStudentID}
                  multiSelect={true}
                  disabled={isAllStudents}
                  onStudentListChange={setStudentList} // Nueva prop para recibir la lista completa
                />
              </div>

              <button
                onClick={handleGenerateStudentsReport}
                disabled={!email || loading}
                className="w-full bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 text-white font-medium py-3 px-4 rounded-lg transition duration-200 flex items-center justify-center gap-2"
              >
                <Download className="h-4 w-4" />
                Generar Reporte de Estudiantes
              </button>
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default FormReportesMasivos;
